import React from "react";
import SearchDoctors from "./components/searchDoctors";

const DoctorReports = () => {
    return (
        <div className="baseContainer">
            <div className="hdngTopCol colBlock respdngHSM">
                <div className="flexRow respdngVHMD alignCntr">
                    <div className="flexMinWidthRow">
                        <h2 className="topHdngTxt">Reports</h2>
                    </div>
                </div>
            </div>
            <div className="flexRow">
                <SearchDoctors />
            </div>
        </div>
    );
};
export default DoctorReports;
